import {Box, useTheme} from "@mui/material";
import React, {PropsWithChildren} from "react";

export interface BoxNumberProps {
	color?: "secondary";
}

export function BoxNumber(props: PropsWithChildren<BoxNumberProps & { children: string }>) {
	const theme = useTheme();
	const {color = "secondary", children} = props;

	const truncateChildren = (text: string): string => {
		return text.length > 16 ? `${text.slice(0, 16)}...` : text;
	};

	return (
		<Box
			sx={{
				bgcolor: theme.palette[color].main,
				color: theme.palette[color].contrastText,
				px: 1.5,
				py: 0.5,
				borderRadius: 1.5,
			}}
		>
			{truncateChildren(children)}
		</Box>
	);
}
